import React, { useEffect, useRef, useState } from "react";
import api from "~/services/api";
import { LandPage, ContainerComm, Main, ThisCarregamento, ThisProgress } from './styles';
import { Colors } from "~/config/Colors";
import { useSelector } from "react-redux";
import { Chart } from "react-google-charts";
import { Materialize } from "~/styles/materializeGrid";

import { Label, Input, Select as SelectCF } from "~/componentes/CustomForm";
import IconInsatisfeito from '~/assets/icones/icon_insatisfeito.png';
import IconMuitoInsatisfeito from '~/assets/icones/icon_muito_insatisfeito.png';
import IconSatisfeito from '~/assets/icones/icon_satisfeito.png';
import IconMuitosatisfeito from '~/assets/icones/icon_muito_satisfeito.png';
import IconNormal from '~/assets/icones/icon_muito_normal.png';
import IconArrowUp from '~/assets/icones/IconArrowUp.svg';
import IconArrowDown from '~/assets/icones/IconArrowDown.svg';

import Select, { StylesConfig } from 'react-select';
import GaugeChart from 'react-gauge-chart';
import { renderToString } from "react-dom/server";

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

import { store } from "~/store";
import { loadingToggle } from "~/store/modules/loadingModal/actions";
import NunitoSemiBold from '~/utils/Nunito-semiBold.js';
import PainelPDF from "./Template/PainelPDF";
import moment from "moment";
import { Table } from "./components/Table";

export default function Painel() {
  const dispatch = store.dispatch;
  const { perfil, idUnidades, controle } = useSelector(state => state.auth);
  const [chartPrincipal, setChartPrincipal] = useState([]);
  const [dataDe, setDataDe] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10));
  const [dataAte, setDataAte] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10));
  const [pesquisas, setPesquisas] = useState();
  const [idPesquisa, setIdPesquisa] = useState();
  const [centroCustos, setCentroCustos] = useState();
  const [centroCustosValue, setCentroCustosValue] = useState();
  const [idCentroCusto, setIdCentroCusto] = useState([]);
  const [servicos, setServicos] = useState();
  const [servicosValue, setServicosValue] = useState();
  const [idServico, setIdServico] = useState([]);
  const [imprimePDF, setImprimePDF] = useState(false);
  const [atualiza, setAtualiza] = useState(false);
  const [data, setData] = useState([]);
  const [commentOpen, setCommentOpen] = useState(true);
  
  const [unidades, setUnidades] = useState([]);
  const [idUnidade, setIdUnidade] = useState([]);
  const [countFilterAvaliation, setCountFilterAvaliation] = useState({
    abertoTotal: true,
    abertoMuitoSatisfeito: true,
    abertoSatisfeito: true,
    abertoNormal: true,
    abertoInsatisfeito: true,
    abertoMuitoInsatisfeito: true,
  });
    
  let countAvaliation = {
    abertoTotal: true,
    total: 0, 
    listaMuitoSatisfeito: [],
    muitoSatisfeito: 0, 
    abertoMuitoSatisfeito: true,
    listaSatisfeito: [],
    satisfeito: 0, 
    abertoSatisfeito: true,
    listaNormal: [],
    normal: 0, 
    abertoNormal: true,
    listaInsatisfeito: [],
    insatisfeito: 0,
    abertoInsatisfeito: true,
    listaMuitoInsatisfeito: [],
    muitoInsatisfeito: 0,
    abertoMuitoInsatisfeito: true,
  };
  let dataAnterior = JSON.parse(localStorage.getItem('@manyflows-comments-v1.0.0')) || [];
  var cronometro = 1;
  
  const cores = [
    "#2E7AD3",
    "#FF5780",
    "#802ED3",
    "#C62ED3",
    "#CAC4C8",
    "#CE6D14",
    "#D32EA5",
    "#14ADCE",
    "#4691C7",
    "#FF9090",
    "#D4F37B",
    "#FFF27E",
    "#4F4F4F",
    "#B9FFDE",
    "#B9D1FF",
  ];

  const chartRefs = useRef([]);
  const filterRef = useRef(null);
  const commentsRefs = useRef([]);
  function atualizaChartPrincipal(data) {
    let lista = [];
    for (const itemData of data) {
      const itemFind = chartPrincipal.find((itemCP) => itemCP.id == itemData.id);
      if (itemFind) {
        lista.push({ ...itemData, aberto: itemFind?.aberto });
      } else {
        lista.push({ ...itemData, aberto: false });
      }
    }
    
    chartRefs.current = [];
    commentsRefs.current = [];
    setChartPrincipal(lista);
  }

  useEffect(() => {
    idPesquisa && api.get('/signed/cliente/pesquisa/dashboard/painel', { params: { dataDe, dataAte, idCentroCusto, idServico, idPesquisa, idUnidade } })
      .then(response => atualizaChartPrincipal(response.data));
      
    idPesquisa && api.get('/signed/cliente/pesquisa/dashboard/painel/comentarios', {
      params: { dataDe, dataAte, idCentroCusto, idServico, idPesquisa, comentario: "S", idUnidade }
    }).then(response => {
      dataAnterior = [];
      localStorage.setItem('@manyflows-comments-v1.0.0', JSON.stringify([]));
    
      setData(response.data);
    });

  }, [dataDe, dataAte, idCentroCusto, idServico, idPesquisa, idUnidade]);

  useEffect(() => {
    api.get('/signed/cliente/gestorservico/gerenciamento/servicos', { params: { ativo: 1, idCentroCusto, idUnidade } })
      .then(response => {
        let lista = [];
        let ids = [];
        for (const item of response.data) {
          ids.push(item?.value);
          lista.push({  value: item?.id, label: item?.titulo, color: "#00B8D9"})
        }
        setServicos(lista);
      });
  }, [idCentroCusto, idUnidade]);

  useEffect(() => {
    api.get('/signed/cliente/pesquisa/gerenciamento/pesquisas', { params: { ativo: 1 } })
      .then(response => {
        setPesquisas(response.data);

        if (response.data.length > 0) {
          setIdPesquisa(response.data[0].id);
        }
      });

    api.get('/signed/cliente/administracao/organizacao/unidades', { params: { centroCusto: "S", servico: "S" } }).then(response => {
      let lista = [];
      for (const item of idUnidades) {
        const itemFind = response?.data?.find((o) => o?.id == item);
        
        if (itemFind) {
          let listaCC = [];
          for (const itemCC of itemFind?.centroCustos) {
            listaCC.push({ value: itemCC?.id, label: itemCC?.titulo, color: "#00B8D9" });
          }

          let listaSer = [];
          for (const itemCC of itemFind?.servicos) {
            listaSer.push({ value: itemCC?.id, label: itemCC?.titulo, color: "#00B8D9" });
          }

          lista.push({ value: itemFind?.id, label: itemFind?.nome, color: "#00B8D9", centroCustos: listaCC, servicos: listaSer });
        }
      }
      setUnidades(lista);
    });

    setInterval(() => {
      if (cronometro == 20) {
        cronometro = 1;
        setAtualiza(true);
      } else {
        cronometro = cronometro + 1;
      }
      
    }, 1000);
  }, []);

  if (data?.length > 0) {
    let lista = [];
    
    for (const element of data) {
      let find = dataAnterior?.find((e) => e?.id == element?.id);
      if (!find) {
        lista.push({ ...element, aberto: false });
      }
    }

    dataAnterior = [...dataAnterior, ...lista];
    localStorage.setItem('@manyflows-comments-v1.0.0', JSON.stringify(dataAnterior));

    let itemAvaliation = {
      abertoTotal: true,
      total: 0, 
      listaMuitoSatisfeito: [],
      muitoSatisfeito: 0, 
      abertoMuitoSatisfeito: true,
      listaSatisfeito: [],
      satisfeito: 0, 
      abertoSatisfeito: true,
      listaNormal: [],
      normal: 0, 
      abertoNormal: true,
      listaInsatisfeito: [],
      insatisfeito: 0,
      abertoInsatisfeito: true,
      listaMuitoInsatisfeito: [],
      muitoInsatisfeito: 0,
      abertoMuitoInsatisfeito: true,
    };
    
    for (const dataAvaliation of dataAnterior) {
      if (dataAvaliation?.percentualSatisfacao > 80) {
        itemAvaliation.muitoSatisfeito += 1;
        itemAvaliation.listaMuitoSatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 60 && dataAvaliation?.percentualSatisfacao <= 80) {
        itemAvaliation.satisfeito += 1;
        itemAvaliation.listaSatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 40 && dataAvaliation?.percentualSatisfacao <= 60) {
        itemAvaliation.normal += 1;
        itemAvaliation.listaNormal.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 20 && dataAvaliation?.percentualSatisfacao <= 40) {
        itemAvaliation.insatisfeito += 1;
        itemAvaliation.listaInsatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao <= 20) {
        itemAvaliation.muitoInsatisfeito += 1;
        itemAvaliation.listaMuitoInsatisfeito.push(dataAvaliation);
      }

      itemAvaliation.total += 1;
    }

    countAvaliation = itemAvaliation;
  }

  const handleDownloadPainel = async () => {
    dispatch(loadingToggle());

    let tituloPesquisa = pesquisas.find((e) => e?.id == idPesquisa);
    let tituloPeriodo = moment(dataDe, "YYYY-MM-DD").format('DD/MM/YYYY') + " Até " + moment(dataAte, "YYYY-MM-DD").format('DD/MM/YYYY');
    let tituloTurno = "";
    let listaCCs = "";

    let count = 0;
    for (const itemCC of idCentroCusto) {
      const itemIdCC = centroCustos.find((e) => e?.value == itemCC);

      if (count == 0) {
        tituloTurno += itemIdCC?.label;
      } else {
        tituloTurno += ", " + itemIdCC?.label;
      }
      
      count++;
    }

    count = 0;
    for (const itemServ of idServico) {
      const itemIdServ = servicos.find((e) => e?.value == itemServ);

      if (count == 0) {
        listaCCs += itemIdServ?.label;
      } else {
        listaCCs += ", " + itemIdServ?.label;
      }

      count++;
    }

  
    let htmlElement = <PainelPDF data={{
      resultado: chartPrincipal,
      tituloPesquisa: tituloPesquisa?.titulo,
      tituloPeriodo,
      nomeUnidade: "",
      tituloTurno,
      listaCCs,
      params: { dataDe, dataAte, idCentroCusto, idServico, idPesquisa, comentario: "S" },
      data,
    }} />;
    
    let elementAsString = renderToString(htmlElement);

    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: 'landscape'
    });
    
    let row = 122;
    let indice = 0;

    doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
    doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
    doc.setFont('Nunito');
    // doc.setFontSize(10);

    for (const element of chartRefs.current) {
      if (element) {
        const imgData = await html2canvas(element, { scale: 3, }).then(canvas => {
          return canvas.toDataURL('image/png');
        });

        if (chartPrincipal[indice]?.tipo == "SF") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 130) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 120);
            row += 130;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        } else if (chartPrincipal[indice]?.tipo == "MP") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 140) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 130);
            row += 140;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        } else if (chartPrincipal[indice]?.tipo == "CF") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 67) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 57);
            row += 67;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        }

        indice++;
      }
    }

    if (filterRef) {
      const imgData = await html2canvas(filterRef.current, { scale: 3, }).then(canvas => {
        return canvas.toDataURL('image/png');
      });

      if ((row + 57) > 460) {
        row = 10;
        doc.addPage();
      }

      doc.addImage(imgData, 'PNG', 10, row, 613, 47);
      row += 57;
    }
    
    indice = 0;
    for (const element of commentsRefs.current) {
      if (element) {
        const imgData = await html2canvas(element, { scale: 3, }).then(canvas => {
          return canvas.toDataURL('image/png');
        });

        if (dataAnterior[indice]?.aberto) {
          let heightText = 30 + 10;

          if ((row + heightText) > 460) {
            row = 10;
            doc.addPage();
          }

          for (const itemComm of dataAnterior[indice]?.comentarios) {
            heightText += (itemComm?.texto.length >= 140 ? 45 : 35);

            if ((row + heightText) > 460) {
              row = 10;
              doc.addPage();
            }
          }

          doc.addImage(imgData, 'PNG', 10, row, 613, heightText - 10);
          row += heightText;
        } else {
          if ((row + 47) > 460) {
            row = 10;
            doc.addPage();
          }

          doc.addImage(imgData, 'PNG', 10, row, 613, 37);
          row += 47;
        }

        indice++;
      }
    }

    doc.html(elementAsString, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
        dispatch(loadingToggle());
      },
    });
    // doc.save("two-by-four.pdf");
  };

  useEffect(() => {
    if (imprimePDF) {
      setImprimePDF(false);
      handleDownloadPainel();
    }
  }, [imprimePDF]);

  useEffect(() => {
    if (atualiza) {
      setAtualiza(false);

      api.get('/signed/cliente/pesquisa/dashboard/painel', { 
        params: { dataDe, dataAte, idCentroCusto, idServico, idPesquisa, idUnidade } 
      }).then(response => atualizaChartPrincipal(response.data));
        
      api.get('/signed/cliente/pesquisa/dashboard/painel/comentarios', {
        params: { dataDe, dataAte, idCentroCusto, idServico, idPesquisa, comentario: "S", idUnidade }
      }).then(response => setData(response.data));
    }
  }, [atualiza]);

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? Colors.Color2
          : undefined,
        color: Colors.Color7,
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : Colors.Color2
            : undefined,
        },
      };
    },
  };

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Materialize className="materialize">
            <div className="row header">
              <div className="divTitle">
                <div className="div-icone">
                  <h4 className="title">Painel</h4>
                  <h5 className="sub-title">Visualize as informações e tenha uma análise prévia das pesquisas</h5>
                </div>
              </div>
              <div className="div-bt">
                <button
                  className="btn-filtro"
                  onClick={() => setImprimePDF(true)}
                >
                  PDF
                </button>
              </div>
            </div>
            <div className="row filtro">
              <Label title="" className="col s2 m2 l2 no-padd-l">
                <SelectCF
                  isNumber
                  list={{ list: pesquisas, value: 'id', label: 'titulo' }}
                  name="idPesquisa"
                  firstOption={"Pesquisa"}
                  defaultValue={idPesquisa}
                  onChange={(e) => {
                    const v = e.currentTarget.value;
                    setIdPesquisa(v);
                  }}
                />
              </Label>
              <Label title="" className="col s3 m3 l4">
                <SelectCF
                  isNumber
                  list={{ list: unidades, value: 'value', label: 'label' }}
                  name="idUnidade"
                  firstOption={"Unidade"}
                  defaultValue={idUnidade}
                  onChange={(e) => {
                    const v = e.currentTarget.value;
                    setIdUnidade(v);

                    let find = unidades?.find((o) => o?.value == v);
                    if (find) {
                      setCentroCustos(find?.centroCustos);
                    }
                  }}
                />
              </Label>
              <Label title="" className="col s3 m3 l3">
                <Select
                  value={centroCustosValue}
                  isMulti
                  name="colors"
                  options={centroCustos}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Centro de Custos"
                  onChange={(e) => {
                    let ids = [];
                    for (const itemE of e) {
                      ids.push(itemE?.value);
                    }
                    setIdCentroCusto(ids);
                    setCentroCustosValue(e);
                  }}
                  styles={colourStyles}
                />
              </Label>
              <Label title="" className="col s3 m3 l3">
                <Select
                  value={servicosValue}
                  isMulti
                  name="colors"
                  options={servicos}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Turnos"
                  onChange={(e) => {
                    let ids = [];
                    for (const itemE of e) {
                      ids.push(itemE?.value);
                    }
                    setIdServico(ids);
                    setServicosValue(e);
                  }}
                  styles={colourStyles}
                />
                {/* <SelectCF
                  isNumber
                  list={{ list: servicos, value: 'id', label: 'titulo' }}
                  name="idServico"
                  firstOption={"Turnos"}
                  onChange={(e) => {
                    const v = e.currentTarget.value;
                    setIdServico(v);
                  }}
                /> */}
              </Label>
            </div>
            <div className="row filtro">
              <Label title="" className="col s2 m2 l2 no-padd-l">
                <Input
                  type="date"
                  name="dataDe"
                  defaultValue={dataDe}
                  onBlur={(e) => {
                    const v = e.currentTarget.value || "";
                    setDataDe(v);
                  }}
                />
              </Label>
              <Label title="" className="col s2 m2 l2">
                <Input
                  type="date"
                  name="dataAte"
                  defaultValue={dataAte}
                  onBlur={(e) => {
                    const v = e.currentTarget.value || "";
                    setDataAte(v);
                  }}
                />
              </Label>
            </div>
          </Materialize>
          <ThisCarregamento></ThisCarregamento>
          <div className="back-section">
            <div className="ref">
              {chartPrincipal?.map((itemPergunta, indicePergunta) => (
                <div 
                  ref={ref => {
                    if (ref) {
                      const find = chartRefs.current.find((item) => item == ref);
                      !find && chartRefs.current.push(ref);
                    }
                  }}
                  data-tkey={itemPergunta?.id}
                  className="section-1" 
                  key={itemPergunta?.id}
                >
                  <div 
                    className="sc-top"
                    onClick={() => {
                      setChartPrincipal((state) => {
                        let lista = [...state];
                        
                        lista[indicePergunta].aberto = !lista[indicePergunta].aberto;

                        return lista;
                      });

                    }}
                  >
                    <div className="div-title">
                      <div className="title">
                        {indicePergunta + 1}. {itemPergunta?.titulo}
                      </div>
                      <div className="total-satis">
                        <div className="resumo">
                          <p className="ct-title">Satisfação</p>
                          <p className="ct-quant">{itemPergunta?.quantidade + " respostas"}</p>
                        </div>
                        {!itemPergunta.aberto && (<img className="icon-arrow" src={IconArrowDown} alt="" />)}
                        {itemPergunta.aberto && (<img className="icon-arrow" src={IconArrowUp} alt="" />)}
                      </div>
                    </div>
                    {!itemPergunta.aberto && (
                      <div className="div-sumary">
                        <div className="list">
                          {itemPergunta?.listaItens?.map((itemItem, a) => (
                            <div className="item-pergunta">
                              {itemPergunta?.tipo == "SF" && (
                                itemItem?.estrela == "1"
                                  ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitosatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "2" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconSatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "3" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconNormal} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "4" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconInsatisfeito} alt="Vazio" />
                                    </div>
                                  ) : (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitoInsatisfeito} alt="Vazio" />
                                    </div>
                                  )
                              )}
                              {itemPergunta?.tipo != "SF" && (
                                <div className="col-2">
                                  <p className="titulo-item">{itemItem?.titulo}</p>
                                </div>
                              )}
                              <div className="col-1-1 align-right">
                                <p className="titulo-item">{(itemItem?.porcentagem || 0)?.toFixed(1)}%</p>
                              </div>
                            </div>
                          ))}
                        </div>
                        {itemPergunta?.tipo == "SF" && (
                          <div className="chart-total">
                            <div className="chart-tt-circle">
                              <GaugeChart id="gauge-chart5"
                                arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                                colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                                textColor={Colors.Color3}
                                hideText={true}
                                percent={itemPergunta?.percentualSatisfacao/100}
                                arcPadding={0.02}
                                needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                                needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                                style={{ width: '90%' }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {itemPergunta.aberto && (
                    <div className="chart-barra">
                      <div className="list">
                        {itemPergunta?.listaItens?.map((itemItem, a) => (
                          <div className="item-pergunta">
                            {
                              itemPergunta?.tipo == "SF" && (
                                itemItem?.estrela == "1"
                                  ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitosatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "2" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconSatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "3" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconNormal} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "4" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconInsatisfeito} alt="Vazio" />
                                    </div>
                                  ) : (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitoInsatisfeito} alt="Vazio" />
                                    </div>
                                  )
                              )
                            }
                            <div className="col-3">
                              <p className="titulo-item">{itemItem?.titulo}</p>
                            </div>
                            <div className="col-3">
                              <div className="progress">
                                {
                                  itemPergunta?.tipo == "SF" ? (
                                    itemItem?.estrela == "1"
                                      ? (
                                        <ThisProgress backgound={'#2ED3B5'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "2" ? (
                                        <ThisProgress backgound={'#B6DF53'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "3" ? (
                                        <ThisProgress backgound={'#FFD147'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "4" ? (
                                        <ThisProgress backgound={'#FFAB48'} width={itemItem?.porcentagem + "%"} />
                                      ) : (
                                        <ThisProgress backgound={'#FF5780'} width={itemItem?.porcentagem + "%"} />
                                      )
                                  ) : (
                                    <ThisProgress backgound={cores[a]} width={itemItem?.porcentagem + "%"} />
                                  )
                                }
                              </div>
                            </div>
                            <div className="col-1 align-right">
                              <p className="titulo-item">{itemItem?.quantidade}</p>
                            </div>
                            <div className="col-1-1 align-center">
                              <p className="titulo-item">|</p>
                            </div>
                            <div className="col-1-1 align-right">
                              <p className="titulo-item">{itemItem?.porcentagem?.toFixed(1)}%</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      {itemPergunta?.tipo == "SF" && (
                        <div className="chart-total">
                          <div className="chart-tt-circle">
                            <GaugeChart id="gauge-chart5"
                              arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                              colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                              textColor={Colors.Color3}
                              percent={itemPergunta?.percentualSatisfacao/100}
                              arcPadding={0.02}
                              needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                              needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                              style={{ width: '90%' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="section-2">
              <div className="ref2">
                <div className="sc-top" ref={filterRef}>
                  <div className="div-title" onClick={() => setCommentOpen(!commentOpen)}>
                    <div className="title">
                      {chartPrincipal.length + 1}. Lista de Comentários
                    </div>
                    {!commentOpen && (<img className="icon-arrow" src={IconArrowDown} alt="" />)}
                    {commentOpen && (<img className="icon-arrow" src={IconArrowUp} alt="" />)}
                  </div>
                  <div className="div-sumary">
                    <div className="list">
                      <div className="item-pergunta">
                        <div className="col-1-1 align-left">
                          <p className="titulo-item">Total</p>
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.total)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="list">
                      <div 
                        className={countFilterAvaliation?.abertoMuitoSatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoMuitoSatisfeito: !state.abertoMuitoSatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconMuitosatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.muitoSatisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoSatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoSatisfeito: !state.abertoSatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconSatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.satisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoNormal ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoNormal: !state.abertoNormal
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconNormal} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.normal)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoInsatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoInsatisfeito: !state.abertoInsatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconInsatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.insatisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoMuitoInsatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoMuitoInsatisfeito: !state.abertoMuitoInsatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconMuitoInsatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.muitoInsatisfeito)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {commentOpen && (
                  <div className="lista-comentarios">
                    <Table 
                      comments={dataAnterior}
                      optionsFilter={countAvaliation}
                      countFilterAvaliation={countFilterAvaliation}
                      commentsRefs={commentsRefs}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </LandPage>
    </Main>
  );
}
